// import facebookLogin from 'facebook-login-vuejs';
import { Donuz } from "@/donuz-js/Donuz";
// @ is an alias to /src
export default {
  name: "login",
  components: {
    // facebookLogin
  },
  data() {
    return {
      cpf: "",
      password: "",
      forgotPassword: null,
      email: ''
    };
  },
  async mounted() {
    var elems = document.querySelectorAll('.modal');
    var instance = M.Modal.init(elems, { opacity: 0.5 });
  },  
  methods: {
    submit: async function (e) {
      e.preventDefault();
      let result = await Donuz.customer.signIn(this.cpf, this.password, this.ESTABELECIMENTO.id);
      if (result.status == 200) {
        M.toast({ html: 'Logado com sucesso!!!', classes: "green" });
        let client = result.clientes[0];
        let saldo = await Donuz.balance.getCustomerBalance(result.token, this.ESTABELECIMENTO.id);
        client.saldo = parseFloat(saldo.saldo)
          .toFixed(2)
          .replace(".", ",");
        sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
        sessionStorage.setItem(btoa("tokenCliente"), result.token);
        location.href = "/" + this.$route.params.slug;
      } else {
        M.toast({ html: 'Senha incorreta!!!<br/> Tente novamente.', classes: "red" });
      }
    },
    forgot: async function () {      
      let result = await Donuz.customer.forgotPassword(this.email, this.ESTABELECIMENTO.id)
      if (result.status == 200) {
        M.toast({ html: 'Sucesso!!!</br>Foi enviado um email com uma nova senha!', classes: "green center-align"});
      } else {
        M.toast({ html: 'Erro!!!</br> tente novamente.', classes: "red center-align"});
      }
      
    },
    // checkLoginState: async function (response) {
    //   let result = await Donuz.customer.signInByFacebook(response.response.authResponse.userID, this.ESTABELECIMENTO.id);

    //   if (result.status == 200) {
    //     M.toast({ html: 'Logado com sucesso!!!', classes: "green" });
    //     let client = result.clientes[0];
    //     let saldo = await Donuz.balance.getCustomerBalance(result.token, this.ESTABELECIMENTO.id);
    //     client.saldo = parseFloat(saldo.saldo)
    //       .toFixed(2)
    //       .replace(".", ",");
    //     sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
    //     sessionStorage.setItem(btoa("tokenCliente"), result.token);
    //     location.href = "/" + this.$route.params.slug;
    //   } else {
    //     M.toast({ html: result.mensagem, classes: "red" });
    //   }
    // },
    // checkLogin: async function (response) {
    //   let result = await Donuz.customer.signInByFacebook(response.authResponse.userID, this.ESTABELECIMENTO.id);

    //   if (result.status == 200) {
    //     M.toast({ html: 'Logado com sucesso!!!', classes: "green" });
    //     let client = result.clientes[0];
    //     let saldo = await Donuz.balance.getCustomerBalance(result.token, this.ESTABELECIMENTO.id);
    //     client.saldo = parseFloat(saldo.saldo)
    //       .toFixed(2)
    //       .replace(".", ",");
    //     sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
    //     sessionStorage.setItem(btoa("tokenCliente"), result.token);
    //     location.href = "/" + this.$route.params.slug;
    //   } else {
    //     M.toast({ html: result.mensagem, classes: "red" });
    //   }
    // }
  }
};
